var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-item-pc",class:_vm.from,style:({backgroundImage: 'url('+_vm.info.imageurl+')'}),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"play-btn"})])}
var staticRenderFns = []

export { render, staticRenderFns }